module.exports = __webpack_public_path__ + "img/22.745447c4.png";